import { useState } from "react";
import { Link, NavLink } from "react-router-dom";

function LockIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      width={13}
      height={13}
      style={{ marginLeft: "auto", flexShrink: 0, color: "var(--gold)" }}
    >
      <rect x={4} y={10} width={16} height={10} rx={2} />
      <path d="M8 10V7a4 4 0 018 0v3" />
    </svg>
  );
}

export default function Sidebar({ isOpen, onClose, isAccountActive }) {
  const [isComplaintOpen, setIsComplaintOpen] = useState(false);
  const [isEarningsOpen, setIsEarningsOpen] = useState(false);
  const [isFundRequestOpen, setIsFundRequestOpen] = useState(false);

  return (
    <>
      <div
        className={`sidebar-overlay${isOpen ? " show" : ""}`}
        onClick={onClose}
      />
      <aside className={`sidebar${isOpen ? " active" : ""}`}>
        <div className="brand-mark">
          <div className="cus-logo-58">
            <img src="/assets/panel/images/white-logo.png" />
          </div>
          <button
            type="button"
            className="sidebar-close-btn"
            onClick={onClose}
            aria-label="Close menu"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              width={16}
              height={16}
            >
              <path d="M18 6L6 18" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="nav-section-label">Overview</div>
        <NavLink
          to="/panel/dashboard"
          className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
          data-page="dashboard"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <rect x={3} y={3} width={7} height={9} rx="1.5" />
            <rect x={14} y={3} width={7} height={5} rx="1.5" />
            <rect x={14} y={12} width={7} height={9} rx="1.5" />
            <rect x={3} y={16} width={7} height={5} rx="1.5" />
          </svg>
          Dashboard
        </NavLink>
        <NavLink
          to="/panel/activate_package"
          className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
          data-page="activate"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <path d="M12 2l2.8 6.2 6.7.6-5.1 4.5 1.6 6.6L12 16.6 6 19.9l1.6-6.6-5.1-4.5 6.7-.6z" />
          </svg>
          Activate Package
        </NavLink>
        <div className="nav-section-label">Fund Request</div>
        <button
          type="button"
          className="nav-item"
          onClick={() => setIsFundRequestOpen((prev) => !prev)}
          style={{
            width: "100%",
            border: "none",
            background: "transparent",
            fontFamily: "inherit",
            cursor: "pointer",
            justifyContent: "space-between",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
            >
              <path d="M6 3h12" />
              <path d="M6 8h12" />
              <path d="M6 13l8.5 8" />
              <path d="M6 13h3" />
              <path d="M9 13c6.667 0 6.667-10 0-10" />
            </svg>
            Add Money
          </span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            width={14}
            height={14}
            style={{
              flexShrink: 0,
              transition: "transform .2s",
              transform: isFundRequestOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
        {isFundRequestOpen && (
          <>
            {/* <Link
              to="/panel/quick_deposit"
              className="nav-item"
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Quick Deposit
            </Link> */}
            <Link
              to="/panel/manual_deposit"
              className="nav-item"
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Manual Deposit
            </Link>
          </>
        )}
        <div className="nav-section-label">Learning</div>
        <NavLink
          to="/panel/courses"
          className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
          data-page="courses"
          data-gated={1}
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
          </svg>
          My Courses
          {!isAccountActive && <LockIcon />}
        </NavLink>
        <div className="nav-section-label">Earnings</div>
        <button
          type="button"
          className="nav-item"
          onClick={() => setIsEarningsOpen((prev) => !prev)}
          style={{
            width: "100%",
            border: "none",
            background: "transparent",
            fontFamily: "inherit",
            cursor: "pointer",
            justifyContent: "space-between",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
            >
              <rect x={2} y={6} width={20} height={14} rx="2.5" />
              <path d="M2 10h20" />
              <circle
                cx="16.5"
                cy={15}
                r="1.4"
                fill="currentColor"
                stroke="none"
              />
            </svg>
            L2E Affiliate
          </span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            width={14}
            height={14}
            style={{
              flexShrink: 0,
              transition: "transform .2s",
              transform: isEarningsOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
        {isEarningsOpen && (
          <>
            <NavLink
              to="/panel/wallets"
              className={({ isActive }) =>
                "nav-item" + (isActive ? " active" : "")
              }
              data-page="wallet"
              data-gated={1}
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Wallets
              {!isAccountActive && <LockIcon />}
            </NavLink>
            <NavLink
              to="/panel/team_reports"
              className={({ isActive }) =>
                "nav-item" + (isActive ? " active" : "")
              }
              data-page="team"
              data-gated={1}
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Reports
              {!isAccountActive && <LockIcon />}
            </NavLink>
          </>
        )}
        <div className="nav-section-label">Help</div>
        <button
          type="button"
          className="nav-item"
          onClick={() => setIsComplaintOpen((prev) => !prev)}
          style={{
            width: "100%",
            border: "none",
            background: "transparent",
            fontFamily: "inherit",
            cursor: "pointer",
            justifyContent: "space-between",
          }}
        >
          <span style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
            >
              <path d="M21 11.5a8.4 8.4 0 01-8.9 8.4 8.7 8.7 0 01-4-1L3 20l1.1-4.3A8.4 8.4 0 1121 11.5z" />
            </svg>
            Complaint
          </span>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            width={14}
            height={14}
            style={{
              flexShrink: 0,
              transition: "transform .2s",
              transform: isComplaintOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
        {isComplaintOpen && (
          <>
            <Link
              to="/panel/create_complain"
              className="nav-item"
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Create Complaint
            </Link>
            <Link
              to="/panel/complain_list"
              className="nav-item"
              style={{ paddingLeft: 40, fontSize: 13 }}
            >
              Complaint List
            </Link>
          </>
        )}
        <div className="nav-section-label">User Information</div>
        <NavLink
          to="/panel/profile"
          className={({ isActive }) => "nav-item" + (isActive ? " active" : "")}
          data-page="profile"
        >
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
          >
            <circle cx={12} cy={8} r={4} />
            <path d="M4 21v-1a8 8 0 0116 0v1" />
          </svg>
          Profile
        </NavLink>
      </aside>
    </>
  );
}
